import { render, staticRenderFns } from "./Airwallex.vue?vue&type=template&id=57d14e24&scoped=true"
import script from "./Airwallex.vue?vue&type=script&lang=js"
export * from "./Airwallex.vue?vue&type=script&lang=js"
import style0 from "./Airwallex.vue?vue&type=style&index=0&id=57d14e24&prod&scoped=true&lang=scss"
import style1 from "./Airwallex.vue?vue&type=style&index=1&id=57d14e24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d14e24",
  null
  
)

export default component.exports